import PhotoBrowserDescription from "./PhotoBrowserDescription";
export default PhotoBrowserDescription;
